import React from 'react'
import { RealEstateFeatures } from '../../../../../@types/types'
import { estateFeatures } from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'

export const houseRentEstateFeaturesList = [
  RealEstateFeatures.EQUIPPED_KITCHEN,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
  RealEstateFeatures.FLAT_SHARE_SUITABLE,
]

export const houseRentEstateFeatures = estateFeatures(houseRentEstateFeaturesList)

export const createHouseRentEstateFeaturesForWebView = (label: React.ReactNode, className: string) =>
  estateFeatures(houseRentEstateFeaturesList, label, className)
